import { Card } from '@/common/ui/Card'
import { MeForm } from '@/app/entities/me/ui'

export const UserProfilePage = () => {
    return (
        <>
            <div className='profile-content'>
                <h2 className='font-medium text-[20px]/[22px]'>Профиль</h2>
            </div>
            <Card className='profile-content card-primary'>
                <div className='grid-cols-2'>
                    <h3 className='text-lg font-medium mb-2'>Данные пользователя</h3>
                </div>
                <MeForm className='two-columns' />
            </Card>
        </>
    )
}
